<template>
  <div class="card">
    <div class="card-header">
      <div class="bolder-title"> Рейтинг <i class="bi bi-info"></i></div>
      <date-picker style="width: 240px" v-model="dates"
                   locale="ru"
                   :clearable="false"
                   format="dd.MM.yyyy"
                   model-type="yyyy-MM-dd"
                   model-auto
                   range multi-calendars
                   :enable-time-picker="false"></date-picker>

    </div>
    <div class="card-body">
      <div class="graph-header">
        <div id="legend-container-1" class="legend">

          <div class="dropdown">
            <ul class="selected">
              <li v-for="resource in resources.filter(x=>x.check)">
                <div class="name">
                  <div class="resource-checkbox">
                    <input type="checkbox" name="" :id="`rating-graph-select-${resource.resource_id}`"
                           v-model="resource.check">
                    <label :for="`rating-graph-select-${resource.resource_id}`">
                    <span :style="{backgroundColor: resource.color, borderColor: resource.color}" class="check"><i
                        class="bi bi-check"></i></span>
                      {{ resource.name || resource.domain }}</label>
                  </div>
                </div>
              </li>

            </ul>
            <button class="" type="button" data-bs-toggle="dropdown" aria-expanded="false" data-bs-auto-close="outside">
              <i class="bi bi-chevron-down"></i>
            </button>
            <ul class="dropdown-menu">
              <li v-for="resource in resources">
                <div class="name">
                  <div class="resource-checkbox">
                    <input type="checkbox" name="" :id="`rating-graph-choice-${resource.resource_id}`"
                           v-model="resource.check">
                    <label :for="`rating-graph-choice-${resource.resource_id}`">
                    <span :style="{backgroundColor: resource.color, borderColor: resource.color}" class="check"><i
                        class="bi bi-check"></i></span>
                      {{ resource.name || resource.domain }}</label>
                  </div>
                </div>
              </li>
            </ul>

          </div>


          <!--          <ul :class="'resource-list r-flex'+(showed?' open':'')">-->

          <!--            <li v-for="resource in resources">-->
          <!--              <div class="name">-->
          <!--                <div class="resource-checkbox">-->
          <!--                  <input type="checkbox" name="" :id="`rating-graph-${resource.resource_id}`" v-model="resource.check">-->
          <!--                  <label :for="`rating-graph-${resource.resource_id}`">-->
          <!--                    <span :style="{backgroundColor: resource.color, borderColor: resource.color}" class="check"><i-->
          <!--                        class="bi bi-check"></i></span>-->
          <!--                    {{ resource.name || resource.domain }}</label>-->
          <!--                </div>-->
          <!--              </div>-->
          <!--            </li>-->
          <!--          </ul>-->
          <!--          <button class="btn show-more" @click="showed=!showed"><i-->
          <!--              :class="'bi bi-chevron-compact-'+(showed?'up':'down')"></i></button>-->

        </div>
        <ul class="nav nav-underline">
          <li v-for="interval in intervals" :class="'nav-item' + (interval.value === active_interval?' active':'')">
            <a href="" :class="'nav-link' + (interval.value === active_interval?' active':'')"
               @click.prevent="active_interval = interval.value">{{ interval.name }}</a>
          </li>

        </ul>
      </div>
      <div class="graph">
        <Line
            v-if="chart_data"
            :options="chartOptions"
            :data="chart_data"
        />
      </div>
    </div>
  </div>

</template>

<script>


import {Line} from "vue-chartjs";
import {Chart as ChartJS, Title, Tooltip, Legend, LineElement, CategoryScale, LinearScale, PointElement} from 'chart.js'

import moment from 'moment';

ChartJS.register(Title, Tooltip, Legend, LineElement, CategoryScale, LinearScale, PointElement)
import htmlLegendPlugin from "@/components/legendPlugin";
import {ReviewApi} from "@/api/reviews";

ChartJS.defaults.plugins.legend.display = false;

const getOrCreateTooltip = (chart) => {
  let tooltipEl = chart.canvas.parentNode.querySelector('div');

  if (!tooltipEl) {
    tooltipEl = document.createElement('div');
    tooltipEl.style.background = 'rgba(255, 255, 255, 1)';
    tooltipEl.style.boxShadow = '0 1px 2px 0 rgba(25, 27, 35, 0.12)';
    tooltipEl.style.borderRadius = '3px';
    tooltipEl.style.color = 'black';
    tooltipEl.style.opacity = 1;
    tooltipEl.style.pointerEvents = 'none';
    tooltipEl.style.position = 'absolute';
    tooltipEl.style.transform = 'translate(-50%, 0)';
    tooltipEl.style.transition = 'all .1s ease';

    const table = document.createElement('table');
    table.style.margin = '0px';

    tooltipEl.appendChild(table);
    chart.canvas.parentNode.appendChild(tooltipEl);
  }

  return tooltipEl;
};

const externalTooltipHandler = (context) => {
  // Tooltip Element
  const {chart, tooltip} = context;
  const tooltipEl = getOrCreateTooltip(chart);

  // Hide if no tooltip
  if (tooltip.opacity === 0) {
    tooltipEl.style.opacity = 0;
    return;
  }

  // Set Text
  if (tooltip.body) {
    const titleLines = tooltip.title || [];
    const bodyLines = tooltip.body.map(b => b.lines);

    const tableHead = document.createElement('thead');

    titleLines.forEach(title => {
      const tr = document.createElement('tr');
      tr.style.borderWidth = 0;

      const th = document.createElement('th');
      th.style.borderWidth = 0;
      const text = document.createTextNode(title);
      th.style.color = '#6C6E79';
      th.style.fontSize = '16px';

      th.appendChild(text);
      tr.appendChild(th);
      tableHead.appendChild(tr);
    });

    const tableBody = document.createElement('tbody');
    bodyLines.forEach((body, i) => {
      const colors = tooltip.labelColors[i];

      const span = document.createElement('span');
      span.style.background = colors.backgroundColor;
      span.style.borderColor = colors.borderColor;
      span.style.borderWidth = '2px';
      span.style.marginRight = '10px';
      span.style.borderRadius = '10px';
      span.style.height = '10px';
      span.style.width = '10px';
      span.style.display = 'inline-block';

      const tr = document.createElement('tr');
      tr.style.backgroundColor = 'inherit';
      tr.style.borderWidth = 0;

      const td = document.createElement('td');
      td.style.borderWidth = 0;

      const text = document.createTextNode(body);

      td.appendChild(span);
      td.appendChild(text);
      tr.appendChild(td);
      tableBody.appendChild(tr);
    });

    const tableRoot = tooltipEl.querySelector('table');

    // Remove old children
    while (tableRoot.firstChild) {
      tableRoot.firstChild.remove();
    }

    // Add new children
    tableRoot.appendChild(tableHead);
    tableRoot.appendChild(tableBody);
  }

  const {offsetLeft: positionX, offsetTop: positionY} = chart.canvas;

  // Display, position, and set styles for font
  tooltipEl.style.opacity = 1;
  tooltipEl.style.left = positionX + tooltip.caretX + 'px';
  tooltipEl.style.top = positionY + tooltip.caretY + 'px';
  tooltipEl.style.font = tooltip.options.bodyFont.string;
  tooltipEl.style.padding = tooltip.options.padding + 'px ' + tooltip.options.padding + 'px';
};

export default {
  name: 'RatingGraph',
  components: {Line},
  props: {},
  data() {
    return {
      active_interval: '',
      intervals: [
        {name: "1Д", value: "day", dates: [moment().subtract(1, 'month').format("YYYY-MM-DD"), moment().format("YYYY-MM-DD")]},
        {name: "1Н", value: "week", dates: [moment().subtract(3, 'month').format("YYYY-MM-DD"), moment().format("YYYY-MM-DD")]},
        {name: "1М", value: "month", dates: [moment().subtract(6, 'month').format("YYYY-MM-DD"), moment().format("YYYY-MM-DD")]},
        {name: "3М", value: "quarter", dates: [moment().subtract(12, 'month').format("YYYY-MM-DD"), moment().format("YYYY-MM-DD")]},
        {name: "6М", value: "half_year", dates: [moment().subtract(24, 'month').format("YYYY-MM-DD"), moment().format("YYYY-MM-DD")]},
        {name: "1Г", value: "year", dates: [moment().subtract(48, 'month').format("YYYY-MM-DD"), moment().format("YYYY-MM-DD")]},
      ],
      dates: [],
      resources: [],
      htmlLegendPlugin: htmlLegendPlugin,
      showed: false
    }
  },

  watch: {
    active_interval(value) {
      const interval = this.intervals.find(x=>x.value === value);
      this.dates = interval.dates;
      this.getData()
    },
  },

  mounted: function () {
    this.active_interval = "month";
  },
  computed: {
    chartOptions() {
      return {
        responsive: true,
        maintainAspectRatio: false,
        aspectRatio: 1,
        layout: {
          padding: 20
        },
        elements: {
          point: {
            radius: 2
          }
        },
        scales: {
          x: {
            grid: {
              display: false
            },

          },
          y: {
            grid: {
              display: false
            },

            ticks: {
              step: 1
            },
            maxTicksLimit: 5,
          },
        },
        interaction: {
          mode: 'index',
          intersect: false,
        },
        plugins: {
          legend: {
            display: false,
          },
          tooltip: {
            enabled: false,
            position: 'nearest',
            external: externalTooltipHandler
          },
          datalabels: {
            formatter: function (value, context) {
              return '';
            }
          }
        }
      }
    },
    chart_data() {
      let datasets = [], labels = [];
      this.resources.filter(x => x.check === true).forEach(resource => {
        if (!labels.length) labels = resource.points.map(x => x.interval)
        datasets.push({
          label: resource.name || resource.domain,
          backgroundColor: resource.color,
          borderColor: resource.color,
          type: 'line',
          fill: false,
          lineTension: 0,
          data: resource.points.map(x => x.rating)
        })
      })
      return {
        labels: labels,
        datasets: datasets
      }
    }
  },

  methods: {
    getData() {
      ReviewApi.rating_graph(this.active_interval, this.dates[0], this.dates[1]).then(response => {
        this.resources = response
        this.resources.map((x, index) => {
          if (!x.color) x.color = `#${Math.floor(Math.random() * 16777215).toString(16).padStart(6, '0')}`;
          if (index < 2) x.check = true
        })
      })
    }
  }
}

</script>
<style scoped lang="scss">
.graph {
  height: 330px;
}

</style>

